export const getURL = (): string => String(window.location);
